import React, { FC } from 'react'

import { Icon4gPlusProps } from './Icon4gPlus.types'
import * as Styled from './styles/Icon4gPlus.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon4gPlus: FC<Icon4gPlusProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon4gPlusProps['size'],
  isResponsive = false,
}: Icon4gPlusProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#85ee0388-5bde-49f6-92bd-fb6e60c4348f__a)' strokeWidth='2'>
          <path
            d='M26.438 24.563h3.5v3a2.39 2.39 0 0 1-1.75 2.375c-2.07.565-6.25.932-6.25-5.875 0-7.375 6.64-6.476 7.625-4.625m-13.625-1.375v12.5m2-3.5h-8.5l6.5-9m17.5 6h6m-3-3v6'
            stroke='#E60000'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M23.938 43.063c10.493 0 19-8.507 19-19 0-10.494-8.507-19-19-19-10.494 0-19 8.506-19 19 0 10.493 8.506 19 19 19Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
        </g>
        <defs>
          <clipPath id='85ee0388-5bde-49f6-92bd-fb6e60c4348f__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default Icon4gPlus
